module.exports = __webpack_public_path__ + "static/derjenige-der-nicht-weiß-zu-lieben-kampft-02-42ef160462efce8cbb66e43db9837088.jpg";